import Header from '../components/site/Header';
import Hero from '../components/site/Hero';
import Marquee from '../components/site/Marquee';
import Showcase from '../components/site/Showcase';
import BentoProducts from '../components/site/BentoProducts';
import Services from '../components/site/Services';
import About from '../components/site/About';
import ContactSection from '../components/site/ContactSection';
import Footer from '../components/site/Footer';

const Home = () => (
  <div className="min-h-screen bg-[#040D1A] text-slate-100">
    <div className="grain-overlay" aria-hidden="true" />
    <Header />
    <main>
      <Hero />
      <Marquee />
      <Showcase />
      <BentoProducts />
      <Services />
      <About />
      <ContactSection />
    </main>
    <Footer />
  </div>
);

export default Home;
